import React, { Component } from "react";
import { DatePicker, TimePicker } from "antd";
import moment from "moment-timezone";
import { map, orderBy } from "lodash";
import { formatToCurrency } from "../../../../Tools/formatToCurrency";

// mapping for cleaning areas
const formattedAreas = {
  "front yard": "Front Yard",
  "back yard": "Back Yard",
  "right side": "Right Side",
  "left side": "Left Side",
  "dog run": "Dog Run",
  "fenced area": "Fenced Area",
};

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: "Weekly",
  bi_monthly: "Every Other Week",
  once: "Just Once",
  twice_weekly: "Twice Weekly",
  monthly: "Monthly",
};

// service type mapping
const SERVICE_TYPE_MAPPING = {
  pet_waste_stations: "Pet Waste Stations",
  pet_waste_station_bags: "Pet Waste Station Bags",
  pet_waste_station_service: "Pet Waste Station Service",
  common_area_cleaning: "Common Area Cleaning",
  trash_can_service: "Trash Can Service",
};

class Reschedule extends Component {
  state = {
    schedule_time: moment().format('HH:MM'),
    schedule_date: moment().format('MM/DD/YYYY'),
    is_locked: false,
    rescheduled_notes: ''
  };

  onLockChange = (e) => {
    this.setState({
      is_locked: e.target.checked,
    });
  };

    //Update Time
    updateTime = (e) => {
      this.setState({
        schedule_time: moment(e).format('HH:mm:ss')
      })
    }

    updateNotes = (e) => {
      this.setState({
        rescheduled_notes: e.target.value
      })
    }

    updateDate = (e) => {
      this.setState({
        schedule_date: moment(e).format('MM/DD/YYYY')
      })
    }
  

    render() {
      const { data } = this.props;
      const dog_suffix =
      data?.service?.service_order?.calculated_price?.pet_count === 1
        ? "dog"
        : "dogs";
      let arr = [];
      if (data?.service?.service_order?.frequency)
        arr.push(
        `${FREQUENCY_MAPPING[data?.service?.service_order?.frequency]} service`
        );
      if (data?.service?.service_order?.area_to_clean?.length > 0)
        arr.push(
        `${formattedAreas[data?.service?.service_order?.area_to_clean?.[0]]}`
        );
      if (data?.service?.service_order?.calculated_price?.pet_count > 0)
        arr.push(
        `${data?.service?.service_order?.calculated_price?.pet_count} ${dog_suffix}`
        );

      return (
        <div className="reschedule_service_wrapper rdrawer">
          <div className="card-row">
            <div className="card-full">
              <h4>Reschedule Service</h4>
              <span className="subject">
                {moment(data.service.scheduled_time)
                  .local()
                  .format("dddd, MMMM Do YYYY")}
              </span>
              <hr />
              <div className="form-group">
                <div className="fitem">
                  <h5 className="name">
                    {data.customer.first_name + " " + data.customer.last_name}
                  </h5>
                  <h5 className="address">
                    {data.service.service_order.service_address.formatted_address}
                  </h5>
                </div>
                <div className="fitem">
                  <ul className="service_list">
                    <li>
                      <label>Next Service</label>
                      <span>
                        {moment(
                          data.service.service_order.next_service_date
                        ).format("ddd, MMM DD")}
                      </span>
                    </li>
                    <li>
                      <label>Frequency</label>
                      <span>{`${FREQUENCY_MAPPING[data?.service?.service_order?.frequency]}`}</span>
                    </li>
                    <li>
                      <label>Day</label>
                      <span>
                        {moment(
                          data.service.service_order.next_service_date
                        ).format("dddd")}
                      </span>
                    </li>
                    <li>
                      <label># of Dogs</label>
                      <span>{data.service.service_order.pet_count}</span>
                    </li>
                  </ul>
                </div>
                <hr />
                <div className="fitem">
                  <div className="sub_section">
                    <h4>Subscription</h4>
                    {data.service.service_order.service_type === "commercial" ? (
                      <React.Fragment>
                        {map(
                          orderBy(
                          data.service.service_order.commercial_detail
                            ?.line_items,
                          "created_at",
                          "asc"
                          ),
                          (obj, index) =>
                            (
                              <div className="list">
                                <div key={index}>
                                  {obj?.frequency &&
                                  `${
                                    FREQUENCY_MAPPING[obj?.frequency]
                                  } service, `}{" "}
                                  {SERVICE_TYPE_MAPPING[obj?.item]}
                                </div>
                                <span>{obj.total ? `${obj.total}` : "$0"}</span>{" "}
                              </div>
                            )
                        )}
                      </React.Fragment>
                    ) : (
                      <span className=" d-flex justify-content-between">
                        <p className="color-252730 mb-10 mr-2">
                          {arr.join(", ")}
                        </p>
                        <strong className="color-22232A">
                        $
                          {
                          data?.service?.service_order?.calculated_price
                            ?.service_base_price
                          }
                        </strong>
                      </span>
                    )}
                  </div>
                </div>
                {data?.service?.service_order?.calculated_price?.recurring_add_ons
                  ?.recurring_addon_items?.length > 0 ? (
                    <div className="fitem">
                      <div className="sub_section">
                        <h4>Addon</h4>

                        {/* <React.Fragment> */}
                        {/* <p className="color-252730 mb-10">
                     */}
                        <div className="list">
                          {/* <div key={index}> */}
                          {map(
                        data?.service?.service_order?.calculated_price
                          ?.recurring_add_ons &&
                          data?.service?.service_order?.calculated_price
                            ?.recurring_add_ons?.recurring_addon_items,
                        (a) => {
                          return `${a.name}, `;
                        }
                          )}
                      (
                          {
                            FREQUENCY_MAPPING[
                          data?.service?.service_order?.calculated_price
                            ?.frequency
                            ]
                          }
                      )
                          <span> ${data?.service?.service_order?.calculated_price?.recurring_add_ons?.total_recurring_addon_cost}</span>
                          {/* </div> */}
                        </div>
                        {/* </React.Fragment>  */}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                <hr />
                <div className="fitem">
                  <div className="sub_section">
                    <div className="list">
                      <h4>Total per visit</h4>
                      <span>
                        {data.service.service_order.service_type === "commercial"
                          ? '$' + formatToCurrency (data.service.service_order.commercial_detail.total)
                          :  '$' + formatToCurrency(data.service.service_order.calculated_price?.total_price_per_service)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="fitem half-fitem">
                  <div className="half-fitem">
                    <label>Date of Service</label>
                    <DatePicker format="MM/DD/YYYY" defaultValue={moment()} 
                      allowClear={false}
                      onChange={(e) => {
                        this.updateDate(e)
                      }}
                    />
                  </div>
                  <div className="half-fitem">
                    <label>Start Time</label>
                    <TimePicker
                      className="swhite"
                      minuteStep={15}
                      defaultPickerValue={moment()}
                      value={this.state.schedule_time ? moment(this.state.schedule_time, "hh:mm") : undefined}
                      onChange={(e) => {
                        this.updateTime(e)
                      }}
                      allowClear={false}
                      format={'h:mm A'}  />
                  </div>
                </div>
                <div className="fitem">
                  <textarea rows="4" placeholder="Message to Customer" onChange={this.updateNotes}></textarea>
                </div>
                <div className="fitem">
                  <div className="fitem-check">
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id="1"
                      onChange={(e) => {
                        this.onLockChange(e);
                      }}
                    />
                    <label htmlFor="1" className="fitem-ck-txt">
                    Lock Service
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button
              className="btn btn-brand btn-bdr"
              onClick={() => {
                this.props.closeRescheduleDrawer(false);
              }}
            >
            Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                this.props.closeRescheduleDrawer(false);
                this.props.rescheduleMultipleServices({
                  uuid: data.uuid,
                  service_uuid: data.service.uuid,
                  schedule_strart_ts: `${moment(this.state.schedule_date).format('YYYY-MM-DD')}T${this.state.schedule_time}`,
                  is_rescheduled: true,
                  rescheduled_notes: this.state.rescheduled_notes,
                  is_locked: this.state.is_locked,
                });
              }}
            >
            Schedule Service
            </button>
          </div>
        </div>
      );
    }
}

export default Reschedule;
